<script setup>
import { RouterLink } from "vue-router"
import { Carousel, Slide } from "vue3-carousel"
import { useI18n } from "vue-i18n"
import "vue3-carousel/dist/carousel.css"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/20/solid"
import { ref } from "vue"

const { t } = useI18n()

const messages = [
  t("hardware-marketplace.shop.banner.promotion-messages.fast-delivery"),
  t("hardware-marketplace.shop.banner.promotion-messages.secure-payments"),
  t("hardware-marketplace.shop.banner.promotion-messages.new-products"),
]

const carouselRef = ref(null)
const next = () => carouselRef.value && carouselRef.value.next()
const prev = () => carouselRef.value && carouselRef.value.prev()
</script>

<template>
  <div class="bg-black text-white px-2 md:px-5 lg:px-20 py-2 text-xs">
    <div class="flex items-center justify-between">
      <!-- Center align carousel/banner -->
      <div class="flex items-center justify-center">
        <div class="flex items-center justify-center">
          <RouterLink to="/">
            <p class="flex items-center text-xs mb-1">
              Par
              <img
                class="h-4 w-4 mx-1"
                src="https://images.ctfassets.net/1b6f0wuf6ave/42P3RP32nltWjyhI0fg0PY/57029d3dbc531bad21cd75c871078436/logo_official_1.svg"
                alt="Company Icon"
              />
              <span class="font-extrabold leading-tight tracking-tighter">
                projetsolaire
              </span>
            </p>
          </RouterLink>
        </div>
      </div>
      <div class="hidden md:flex items-center justify-center">
        <ChevronLeftIcon
          class="w-5 h-5 text-gray-400 cursor-pointer hover:text-white"
          @click="prev"
        />
        <div class="w-[500px] md:w-[800px] mx-auto">
          <Carousel
            ref="carouselRef"
            :items-to-show="1"
            :wrap-around="true"
            :autoplay="3000"
            :transition="500"
            class="w-full"
          >
            <Slide v-for="(message, index) in messages" :key="index">
              <p class="text-center text-white overflow-hidden text-ellipsis">
                {{ message }}
              </p>
            </Slide>
          </Carousel>
        </div>
        <ChevronRightIcon
          class="w-5 h-5 text-gray-400 cursor-pointer hover:text-white"
          @click="next"
        />
      </div>
      <!-- Right Aligned Banner Items -->
      <div class="flex items-center space-x-3">
        <router-link :to="{ name: 'About' }" class="hover:underline">{{
          $t("hardware-marketplace.shop.banner.links.about")
        }}</router-link>
        <span class="text-gray-500">|</span>
        <router-link :to="{ name: 'BlogHome' }" class="hover:underline">{{
          $t("hardware-marketplace.shop.banner.links.blog")
        }}</router-link>
        <span class="text-gray-500">|</span>
        <router-link :to="{ name: 'HelpInstaller' }" class="hover:underline">{{
          $t("hardware-marketplace.shop.banner.links.help")
        }}</router-link>
        <span class="text-gray-500">|</span>
        <router-link
          :to="{ name: 'HardwareMarketplaceSupport' }"
          class="hover:underline"
          >{{
            $t("hardware-marketplace.shop.banner.links.support")
          }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<style scoped>
.carousel__slide {
  padding: 0;
  text-align: center;
}

.carousel__viewport {
  perspective: 2000px;
}

.carousel__track {
  transform-style: preserve-3d;
}

.carousel__slide--sliding {
  transition: 0.5s;
}

.carousel__slide {
  opacity: 0.9;
}

.carousel__slide--active {
  opacity: 1;
}
</style>
